import {
  AcceptInviteModal,
  DownloadUpdateInfoModal,
  FetchZipModal,
  MessageCTAModal,
  MessageModal,
  MessageUpdateInfoModal,
  PartsModal,
  RequirementsModal,
} from "components/noticepage_components/modals"

import { RegisterAppModal } from "components/page-components/Ausschreibungsdienste/demosearch/modals"

import {
  NoticeDetails,
  NoticeDownloads,
  NoticeMessages,
  NoticeOverview,
  NoticePageDemosearch,
  NoticePageTabs,
  PickNoticeParts,
} from "components/noticepage_components"
import { createTitleTags } from "components/noticepage_components/utils"
import React, { useEffect, useState, useRef } from "react"

import { Helmet } from "react-helmet"
import Layout from "components/structure-components/layout"
import { SEOComponent } from "components/seo-components"
import doenerCase from "scripts/doenerCase"
import { graphql } from "gatsby"
import qs from "qs"

import { WistiaVideoModal } from "components/page-components/Video"

const NoticePage = ({
  data,
  invite_code,
  is_magic_word_invite = false,
  is_direct_invite = false,
  is_preproduction_preview = false,
  preproduction_type = "",
  location,
  remote_invite_data,
}) => {
  const {
    Notice: {
      ActBefore,
      CompletitionDeadline,
      Parts,
      RefIDStringBI,
      ScopeOfServices,
      ServiceTypeName,
      TenderType,
      TenderTypeName,
      TitelOnline,
      ValidUntil,
      ZoneOfRequest,
      ZoneOfRequestName,
      awarding_authority_address = {},
      bi_platform = data?.Notice?.bi_platform || is_preproduction_preview,
      buyer_string,
      categories_data,
      categories_id_primary,
      categories_ids,
      content_html_preview,
      paywall_preview_type,
      places_of_delivery_struct,
    },
  } = data
  const has_parts = Parts?.length > 1

  const overview_ref = useRef(null)
  const downloads_ref = useRef(null)
  const messages_ref = useRef(null)
  const details_ref = useRef(null)
  const [current_ref, set_current_ref] = useState(null)
  const tab_ref_correlation = {
    overview: { tab: 0, ref: overview_ref },
    downloads: { tab: 1, ref: downloads_ref },
    messages: { tab: 2, ref: messages_ref },
    details: { tab: 3, ref: details_ref },
  }

  const [message_cta_modal_open, set_message_cta_modal_open] = useState("")

  const [register_app_modal_active, set_register_app_modal_active] =
    useState(false)

  const close_register_app_modal = (e) => {
    e?.preventDefault()
    set_register_app_modal_active(false)
  }
  const toggle_register_app_modal = (e) => {
    e?.preventDefault()
    set_register_app_modal_active(!register_app_modal_active)
  }

  const [picked_part, set_picked_part] = useState(
    has_parts ? "none" : !!Parts ? Parts?.[0] : undefined
  )
  const [parts_modal_open, set_parts_modal_open] = useState("")

  const [current_cat_id, set_current_cat_id] = useState(categories_id_primary)

  const [current_category_data, set_current_category_data] = useState(
    categories_data?.find(({ category_id }) => category_id === current_cat_id)
  )
  const [info_notification_open, set_info_notification_open] = useState(true)
  const [fetch_zip_modal_open, set_fetch_zip_modal_open] = useState(false)

  const [category_from_params, set_category_from_params] = useState(null)

  const [max_container_height, set_max_container_height] = useState(undefined)

  const [message_modal_state, set_message_modal_state] = useState({})

  const [remote_data, set_remote_data] = useState(
    is_direct_invite || is_magic_word_invite
      ? { ...remote_invite_data }
      : {
          messages: false,
          documents: false,
          details: false,
          proofs: false,
          failed_request: false,
          vu_urls: false,
          zip_download: {},
        }
  )

  const [clicked_disabled_tab, set_clicked_disabled_tab] = useState(false)

  const [download_update_info_modal_open, set_download_update_info_modal_open] =
    useState(false)
  const [message_update_info_modal_open, set_message_update_info_modal_open] =
    useState(false)

  const [accept_invite_modal_open, set_accept_invite_modal_open] = useState("")
  const open_accept_invite_modal = () =>
    set_accept_invite_modal_open("is-active")

  const [requirements_modal_open, set_requirements_modal_open] = useState("")

  const open_requirements_modal = (e) => {
    e?.preventDefault()
    set_requirements_modal_open("is-active")
  }

  const [current_tab, set_current_tab] = useState(0)

  const reset = () => {
    set_current_ref(overview_ref)
    set_current_tab(0)
    set_picked_part(has_parts ? "none" : undefined)
  }
  const teilnahme_click = (e) => {
    e.preventDefault()
    set_current_ref(tab_ref_correlation.details.ref)
    set_current_tab(tab_ref_correlation.details.tab)
  }

  const unterlagen_click = (e) => {
    e.preventDefault()
    set_current_ref(tab_ref_correlation.downloads.ref)
    set_current_tab(tab_ref_correlation.downloads.tab)
  }
  const mitteilungen_click = (e) => {
    e.preventDefault()
    set_current_ref(tab_ref_correlation.messages.ref)
    set_current_tab(tab_ref_correlation.messages.tab)
  }

  const toggle_parts_modal = (e) => {
    e.preventDefault()
    set_parts_modal_open("is-active")
  }

  const get_url_params = (location, categories_ids) => {
    const query_params = qs.parse(location.search.slice(1))
    const url_category = query_params["category_string"]
    const valid_param_category =
      !!url_category && categories_ids?.includes(url_category)

    return valid_param_category ? url_category : null
  }

  const get_remote_data = async (part_id) => {
    const response = await fetch(
      `https://publictender.bi-medien.de/api/Part/${part_id}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )

    const rem_data = await response?.json()
    if (response.ok) {
      set_remote_data({
        messages: rem_data["messages"],
        proofs: rem_data["proofs"],
        documents: rem_data["documents"],
        zip_download: {
          zip_url: rem_data["zipLink"],
        },
        details: {
          ...(rem_data["tender"]?.["options"] || {}),
          CompletitionDeadline: CompletitionDeadline,
          applicationDate: rem_data["applicationDate"],
          bindDate: rem_data["bindDate"],
          submissionDate: rem_data["submissionDate"],
          documentFromDate: rem_data["documentFromDate"],
          prequalificationIssuers:
            rem_data["tender"]?.["prequalificationIssuers"],
        },
      })
    } else {
      set_remote_data({
        failed_request: true,
        fail_msg: rem_data["Message"],
      })
      console.log(rem_data)
    }
  }

  useEffect(() => {
    bi_platform && !is_direct_invite && get_remote_data(Parts?.[0].Id)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const url_params = get_url_params(location, categories_ids)
    set_category_from_params(url_params)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!category_from_params) {
      set_current_cat_id(category_from_params)
    }
  }, [category_from_params])

  useEffect(() => {
    bi_platform &&
      set_max_container_height(
        current_ref?.current?.clientHeight
          ? current_ref?.current?.clientHeight + 20
          : undefined
      )
  }, [current_ref, remote_data, info_notification_open]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    set_current_category_data(
      categories_data?.find(({ category_id }) => category_id === current_cat_id)
    )
  }, [current_cat_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const main_place_of_delivery = places_of_delivery_struct?.[0]?.City

  const linked_landingpages = categories_data.filter(
    ({ landingpage_link }) => !!landingpage_link
  )
  const date_in_millis = new Date((ActBefore || ValidUntil) * 1000)
  const [already_expired, set_already_expired] = useState(false)

  useEffect(() => {
    set_already_expired(date_in_millis < Date.now())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const display_date_config =
    !!ActBefore || !!ValidUntil
      ? bi_platform &&
        ![3, 5, 7, 8, 15].includes(TenderType) &&
        !(
          date_in_millis.getHours() === 23 && date_in_millis.getMinutes() === 59
        )
        ? {
            timeZone: "Europe/Berlin",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
          }
        : {
            timeZone: "Europe/Berlin",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }
      : null

  const display_date = is_preproduction_preview
    ? ""
    : !!ActBefore || !!ValidUntil
      ? new Intl.DateTimeFormat("de-DE", display_date_config).format(
          date_in_millis
        )
      : null

  const [show_video_modal, set_show_video_modal] = useState(false)

  const show_video = () => {
    const { scrollY } = window
    Object.assign(document.body.style, {
      position: "fixed",
      top: `-${scrollY}px`,
      overflow: "hidden",
      width: "100vw",
    })
    set_show_video_modal(true)
  }

  const close_video = () => {
    const scrollY = document.body.style.top
    Object.assign(document.body.style, {
      position: "",
      top: "",
      overflow: "unset",
      width: "",
    })
    window.scrollTo(0, parseInt(scrollY || "0") * -1)
    set_show_video_modal(false)
  }
  useEffect(() => {
    return () => {
      Object.assign(document.body.style, {
        position: "",
        top: "",
        overflow: "unset",
        width: "",
      })
    }
  }, [])

  const [title_tag, h1_tag] = is_preproduction_preview
    ? [TitelOnline, preproduction_type]
    : createTitleTags({
        current_category_data,
        current_cat_id,
        main_place_of_delivery,
        TitelOnline,
        ZoneOfRequest,
        bi_platform,
      })

  const description =
    is_direct_invite || is_preproduction_preview
      ? title_tag
      : `${
          !!display_date ? `Abgabefrist: ${display_date.split(",")[0]}. ` : ""
        }Finden Sie diese und weitere ${
          current_category_data?.notice_count - 1
        } Öffentliche ${
          current_cat_id?.slice(0, 4) === "r003" ? "und private " : ""
        }Ausschreibungen für ${
          current_category_data?.seo_name
        } auf bi-medien.de.
  `
  const breadcrumb_array_base = [
    {
      type: "BreadcrumbLink",
      content: `B_I MEDIEN`,
      link: `/`,
      react_key: "footer_breadcrumb_item_0",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Aufträge finden`,
      link: `/ausschreibungsdienste`,
      react_key: "footer_breadcrumb_item_1",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Ausschreibungen`,
      link: `/ausschreibungsdienste/ausschreibungen`,
      react_key: "footer_breadcrumb_item_2",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Region`,
      link: `/ausschreibungsdienste/ausschreibungen/region`,
      react_key: "footer_breadcrumb_item_3",
      ressort: "ausschreibungsdienste",
    },
  ]
  const breadcrumb_array = [
    ...breadcrumb_array_base,
    ...(!is_preproduction_preview
      ? [
          {
            type: "BreadcrumbLink",
            content: `Ausschreibungen aus ${places_of_delivery_struct?.[0]?.State}`,
            link: `/ausschreibungsdienste/ausschreibungen/region/${doenerCase(
              places_of_delivery_struct?.[0]?.State || ""
            )}`,
            react_key: "footer_breadcrumb_item_4",
            ressort: "ausschreibungsdienste",
          },
        ]
      : []),
    {
      type: "BreadcrumbSpan",
      content: TitelOnline,
      link: "",
      react_key: "footer_breadcrumb_item_5",
      ressort: "mitternachtsblau",
      ignore_json: true,
    },
  ]

  const delete_date = new Date((ValidUntil + 1200000) * 1000).toISOString()
  return (
    <Layout {...{ location, breadcrumb_array }}>
      <SEOComponent
        canonical={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}${
          category_from_params ? `?category_string=${category_from_params}` : ""
        }`}
        brand="B_I ausschreibungsdienste"
        title={title_tag}
        description={description || title_tag}
      />
      <Helmet>
        {is_direct_invite ? <meta name="robots" content="noindex" /> : null}
        <meta name="robots" content={`unavailable_after: ${delete_date}`} />
      </Helmet>
      {show_video_modal && !bi_platform ? (
        <WistiaVideoModal
          {...{ modal_active: show_video_modal, close_modal: close_video }}
        />
      ) : null}
      {bi_platform ? (
        <React.Fragment>
          <FetchZipModal
            {...{
              fetch_zip_modal_open,
              set_fetch_zip_modal_open,
            }}
          />
          <MessageCTAModal
            {...{
              message_cta_modal_open,
              set_message_cta_modal_open,
            }}
          />
          <MessageModal
            {...{
              message_modal_state,
              set_message_modal_state,
              set_message_cta_modal_open,
            }}
          />
          <AcceptInviteModal
            {...{
              invite_code,
              accept_invite_modal_open,
              set_accept_invite_modal_open,
            }}
          />
          <RequirementsModal
            {...{
              requirements_modal_open,
              set_requirements_modal_open,
            }}
          />
          <DownloadUpdateInfoModal
            {...{
              application_required: remote_data?.details?.isApplicationRequired,
              download_update_info_modal_open,
              set_download_update_info_modal_open,
            }}
          />
          <MessageUpdateInfoModal
            {...{
              application_required: remote_data?.details?.isApplicationRequired,
              message_update_info_modal_open,
              set_message_update_info_modal_open,
            }}
          />
        </React.Fragment>
      ) : null}
      <div className="has-background-mitternachtsblau-5 pb-6">
        <div className="container pt-6">
          <div className="columns mb-0">
            <div className="column mt-auto pb-0">
              <h1
                className={
                  bi_platform
                    ? "has-text-weight-bold has-text-mitternachtsblau mb-3"
                    : "title is-2 has-text-mitternachtsblau mb-3"
                }
              >
                {h1_tag}
              </h1>
              <div
                style={{ width: "auto" }}
                role="button"
                tabIndex="-1"
                onKeyDown={() => {}}
                aria-label="Close Success Modal"
                onClick={bi_platform ? reset : undefined}
              >
                <h2
                  className={
                    bi_platform
                      ? "title is-2 has-text-mitternachtsblau mb-0 is-clickable"
                      : "has-text-weight-bold has-text-mitternachtsblau mb-0"
                  }
                >
                  {TitelOnline}
                </h2>
              </div>
            </div>
            <div className="column is-narrow pb-0">
              <div
                className="tag is-mitternachtsblau-10 px-4 mb-auto"
                style={{ borderRadius: "12px" }}
              >
                ID: {RefIDStringBI}
              </div>
            </div>
          </div>
          {has_parts ? (
            <PickNoticeParts
              {...{ Parts, picked_part, toggle_parts_modal, reset }}
            />
          ) : null}
          <hr className="is-mitternachtsblau-30 mx-3 mt-3 is-hidden-print" />
          {bi_platform || is_magic_word_invite ? (
            <NoticePageTabs
              {...{
                current_tab,
                has_parts,
                info_notification_open,
                is_magic_word_invite,
                has_vu_urls: !!remote_data?.vu_urls?.[0],
                mitteilungen_click,
                toggle_parts_modal,
                open_requirements_modal,
                picked_part,
                set_clicked_disabled_tab,
                set_current_ref,
                set_current_tab,
                set_info_notification_open,
                tab_ref_correlation,
                teilnahme_click,
                unterlagen_click,
              }}
            />
          ) : null}
          <div
            className="columns is-mobile is-clipped is-gapless"
            style={{
              maxHeight: max_container_height,
              transition: `all .3s ease`,
            }}
          >
            <div
              className="column is-full"
              style={{
                transition: `all .3s ease`,
                transform:
                  picked_part === "none"
                    ? "translateX(0%)"
                    : current_tab > 0
                      ? "translateX(-30%)"
                      : current_tab < 0
                        ? "translateX(30%)"
                        : "translateX(0%)",
                opacity:
                  picked_part === "none" ? "1" : current_tab === 0 ? "1" : "0",
                visibility:
                  picked_part === "none"
                    ? "visible"
                    : current_tab === 0
                      ? "visible"
                      : "hidden",
              }}
            >
              <div ref={overview_ref}>
                <NoticeOverview
                  {...{
                    ActBefore,
                    CompletitionDeadline,
                    RefIDStringBI,
                    ScopeOfServices,
                    ServiceTypeName,
                    TenderTypeName,
                    ValidUntil,
                    ZoneOfRequestName,
                    already_expired,
                    awarding_authority_address,
                    bi_platform,
                    buyer_string,
                    content_html_preview,
                    display_date,
                    has_parts,
                    is_direct_invite,
                    is_magic_word_invite,
                    is_preproduction_preview,
                    linked_landingpages,
                    mitteilungen_click,
                    open_accept_invite_modal,
                    paywall_preview_type,
                    picked_part,
                    places_of_delivery_struct,
                    show_video,
                    teilnahme_click,
                    toggle_register_app_modal,
                    unterlagen_click,
                  }}
                />
              </div>
            </div>

            <div
              className="column is-full p-0"
              style={{
                transition: `all .3s ease`,
                transform:
                  current_tab > 1
                    ? "translateX(-130%)"
                    : current_tab < 1
                      ? "translateX(-70%)"
                      : picked_part !== "none" && "translateX(-100%)",
                opacity:
                  current_tab === 1 && picked_part !== "none" ? "1" : "0",
                visibility:
                  current_tab === 1 && picked_part !== "none"
                    ? "visible"
                    : "hidden",
              }}
            >
              <div ref={downloads_ref}>
                <NoticeDownloads
                  {...{
                    application_required:
                      remote_data?.details?.isApplicationRequired,
                    has_parts,
                    zip_download: remote_data?.zip_download,
                    documents: remote_data?.documents,
                    failed_request: remote_data?.failed_request,
                    fail_msg: remote_data?.fail_msg,
                    info_notification_open,
                    pq_accepted:
                      remote_data?.details
                        ?.arePreQualificationCertificatesAccepted,
                    proofs: remote_data?.proofs,
                    vu_urls: remote_data?.vu_urls,
                    set_download_update_info_modal_open,
                    fetch_zip_modal_open,
                    set_fetch_zip_modal_open,
                    set_info_notification_open,
                    RefIDStringBI,
                  }}
                />
              </div>
            </div>
            <div
              className="column is-full p-0"
              style={{
                transition: `all .3s ease`,
                transform:
                  current_tab > 2
                    ? "translateX(-230%)"
                    : current_tab < 2
                      ? "translateX(-170%)"
                      : picked_part !== "none" && "translateX(-200%)",
                opacity:
                  current_tab === 2 && picked_part !== "none" ? "1" : "0",
                visibility:
                  current_tab === 2 && picked_part !== "none"
                    ? "visible"
                    : "hidden",
              }}
            >
              <div ref={messages_ref}>
                <NoticeMessages
                  {...{
                    has_parts,
                    fail_msg: remote_data?.fail_msg,
                    failed_request: remote_data?.failed_request,
                    info_notification_open,
                    messages: remote_data?.messages,
                    set_info_notification_open,
                    set_message_cta_modal_open,
                    set_message_modal_state,
                    set_message_update_info_modal_open,
                    RefIDStringBI,
                  }}
                />
              </div>
            </div>
            <div
              className="column is-full p-0"
              style={{
                transition: `all .3s ease`,
                transform:
                  current_tab > 3
                    ? "translateX(-330%)"
                    : current_tab < 3
                      ? "translateX(-270%)"
                      : picked_part !== "none" && "translateX(-300%)",
                opacity:
                  current_tab === 3 && picked_part !== "none" ? "1" : "0",
                visibility:
                  current_tab === 3 && picked_part !== "none"
                    ? "visible"
                    : "hidden",
              }}
            >
              <div ref={details_ref}>
                <NoticeDetails
                  {...{
                    fail_msg: remote_data?.fail_msg,
                    failed_request: remote_data?.failed_request,
                    details: remote_data?.details,
                    RefIDStringBI,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {paywall_preview_type !== "unavailable" ? <NoticePageDemosearch /> : null}

      {!bi_platform ? (
        <RegisterAppModal
          {...{
            modal_active: register_app_modal_active,
            close_modal: close_register_app_modal,
          }}
        />
      ) : !!bi_platform && has_parts ? (
        <PartsModal
          {...{
            Parts,
            TitelOnline,
            clicked_disabled_tab,
            get_remote_data,
            open_requirements_modal,
            parts_modal_open,
            picked_part,
            reset,
            set_parts_modal_open,
            set_picked_part,
            set_clicked_disabled_tab,
            set_current_ref,
            set_current_tab,
            tab_ref_correlation,
          }}
        />
      ) : null}
    </Layout>
  )
}

export default NoticePage

export const pageQuery = graphql`
  query ($id: String!) {
    Notice: noticeDoc(id: { eq: $id }) {
      ActBefore
      bi_platform
      buyer_string
      categories_ids
      categories_id_primary
      categories_data {
        category_id
        landingpage_link
        level
        notice_count
        seo_name
        short_name
      }
      CompletitionDeadline
      content_html_preview
      TitelOnline
      places_of_delivery_struct {
        PostalCode
        State
        City
        city_lp_data {
          city_lp_name
          city_lp_state
        }
      }
      ServiceTypeName
      RefIDStringBI
      Parts {
        SubmissionDate
        Number
        ScopeOfServices
        Name
        CompletitionDeadline
        ApplicationUntil
        Id
      }
      TenderType
      ScopeOfServices
      paywall_preview_type
      ValidUntil
      TenderTypeName
      ZoneOfRequest
      ZoneOfRequestName
    }
  }
`
